<template>
  <div class="filters-container">
    <div class="filter-row">
        <label>Time:</label>
        <div class="pills">
            <button v-for="opt in timeOptions" :key="opt" 
                class="pill-btn" 
                :class="{ active: filters.time === opt }"
                @click="toggleFilter('time', opt)">
                {{ opt }} min
            </button>
        </div>
    </div>

    <div class="filter-row">
        <label>Focus:</label>
        <div class="pills">
            <button v-for="opt in focusOptions" :key="opt" 
                class="pill-btn" 
                :class="{ active: filters.focus.includes(opt) }"
                @click="toggleMultiFilter('focus', opt)">
                {{ opt }}
            </button>
        </div>
    </div>

    <div class="filter-row">
        <label>Pace:</label>
        <div class="pills">
             <button v-for="opt in paceOptions" :key="opt" 
                class="pill-btn" 
                :class="{ active: filters.pace === opt }"
                @click="toggleFilter('pace', opt)">
                {{ opt }}
            </button>
        </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';

export default {
  name: 'PredefinedPlanFilters',
  emits: ['update:filters'],
  setup(props, { emit }) {
    const filters = ref({
        time: null,
        focus: [],
        pace: null
    });

    const timeOptions = ["5-10", "10-20", "20+"];
    const focusOptions = ["Whole Bible", "Old Testament Only", "New Testament Only", "Chronological Order", "Deep Study"];
    const paceOptions = ["Flexible", "Challenging"];

    const toggleFilter = (cat, val) => {
        if (filters.value[cat] === val) filters.value[cat] = null;
        else filters.value[cat] = val;
    };

    const toggleMultiFilter = (cat, val) => {
        const idx = filters.value[cat].indexOf(val);
        if (idx > -1) filters.value[cat].splice(idx, 1);
        else filters.value[cat].push(val);
    };

    watch(filters, (newVal) => {
        emit('update:filters', newVal);
    }, { deep: true });

    return {
        filters,
        timeOptions,
        focusOptions,
        paceOptions,
        toggleFilter,
        toggleMultiFilter
    }
  }
}
</script>

<style scoped>
.filters-container {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 30px;
}

.filter-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}
.filter-row:last-child { margin-bottom: 0; }

.filter-row label {
    width: 60px;
    font-weight: 600;
    color: #888;
}

.pills {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.pill-btn {
    padding: 6px 16px;
    border-radius: 20px;
    border: 1px solid rgba(255,255,255,0.2);
    background: transparent;
    color: #ccc;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s;
}

.pill-btn:hover {
    border-color: #fff;
    color: #fff;
}

.pill-btn.active {
    background: rgb(var(--v-theme-primary));
    color: #0f1111;
    border-color: rgb(var(--v-theme-primary));
    font-weight: 600;
}

@media (max-width: 768px) {
    .filter-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
    .filter-row label {
        width: auto;
        margin-bottom: 4px;
        font-size: 0.9rem;
    }
}
</style>
